<!-- <div *ngIf="isComponentReadyToStart"> -->
    <!-- Rebate Request - Measurement Committee / Economic Committee - Confirm Ship Passing -->
    <div *ngIf="!isRequestSucceeded">
        <!-- Form Title -->
        <h2 class="sectionTitle">Confirm Ship Passing</h2>
        <div *ngIf="formMode == 2" class="bs-callout bs-callout-info"> 
            <p>This Rebate Request's Ship Passing has been Confirmed</p>
        </div>
        <!-- Rebate Request - Display Mode -->
        <app-rebate-request #rebateRequest (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)"></app-rebate-request>
        <div [class.read-only-content]="formMode == 2">
            <form name="form" #f="ngForm">
                <div class="form-container">
                    <div class="form-section">
                        <h4 class="section-title">Confirm Ship Passing</h4>
                        <!-- Ship Passed -->
                        <div class="form-group">
                            <label>Ship Passed</label>
                            <span *ngIf="formMode == 1" class="red"> *</span>
                            <div>
                                <div class="custom-Radio">
                                    <input [disabled]="formMode == 2" type="radio" [(ngModel)]="confirmShipPassingRequest.IsShipPassedString" id="rbtnShipPassedYes" name="ShipPassed" value="true" (change)="onShipPassedChange()" required #isShipPassed="ngModel" />
                                    <label for="rbtnShipPassedYes">Yes</label>
                                </div>
                                <div class="custom-Radio">
                                    <input [disabled]="formMode == 2" type="radio" [(ngModel)]="confirmShipPassingRequest.IsShipPassedString" id="rbtnShipPassedNo" name="ShipPassed" value="false" (change)="onShipPassedChange()" required #isShipPassed="ngModel" />
                                    <label for="rbtnShipPassedNo">No</label>
                                </div>
                            </div>
                            <div *ngIf="isFormSubmitted && isShipPassed?.invalid" class="red">
                                <span *ngIf="isShipPassed?.errors?.required">This Field is Required</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="confirmShipPassingRequest.IsShipPassed" class="form-section">
                        <!-- Voyage Actual Option -->
                        <div class="form-group">
                            <label>Voyage Actual Option</label>
                            <span *ngIf="formMode == 1" class="red"> *</span>
                            <div *ngFor="let longHaulRequestOption of getRequestOptionsDetailsResponse.LongHaulRequestOptionsFormulatedDecision; let i = index;">
                                <div class="custom-Radio">
                                    <input [disabled]="formMode == 2" type="radio" [(ngModel)]="confirmShipPassingRequest.LongHaulRequestOptionId" id="rbtnLongHaulRequestOption_{{longHaulRequestOption?.Id}}" name="LongHaulRequestOptions_{{longHaulRequestOption?.Id}}" value="{{longHaulRequestOption?.Id}}" (change)="onOptionSelect(i)" />
                                    <label for="rbtnLongHaulRequestOption_{{longHaulRequestOption?.Id}}">Option {{i + 1}} ({{longHaulRequestOption?.LastPortOfOrigin}} - {{longHaulRequestOption?.FirstPortOfDestination}})</label>
                                </div>
                            </div>
                            <div *ngIf="isOptionSelectionNotValid" class="red">
                                <span>Please select an Option to Proceed</span>
                            </div>
                        </div>
                        <div *ngIf="isOptionDetailsEnabled && confirmShipPassingRequest.IsShipPassed" [class.read-only-content]="formMode == 1" class="form-section">
                            <h4 class="section-title">Voyage Confirmed Rebate Percentage</h4>
                            <!-- Rebate Percentage -->
                            <div class="form-group">
                                <label for="txtRebatePercentage">Rebate Percentage</label>
                                <div class="input-group">
                                    <label name="SuggestedRebate" id="lblSuggestedRebate" class="form-control">{{selectedLongHaulRequestRequestorDecisionOption.RebatePercentage}}</label>
                                    <span class="input-group-addon">%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="confirmShipPassingRequest.IsShipPassed" class="form-section">
                        <!-- Passing Date -->
                        <div class="form-group">
                            <label for="dpPassingDate">Passing Date</label>
                            <span *ngIf="formMode == 1" class="red"> *</span>
                            <input [disabled]="formMode == 2" [(ngModel)]="confirmShipPassingRequest.PassingDate" #passingDateDatepicker="bsDatepicker" bsDatepicker [minDate]='null' [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour, maxDate: passingDateMaxDate}" id="dpPassingDate" class="form-control" name="PassingDate" (ngModelChange)="onPassingDateChange()" />
                            <timepicker [disabled]="formMode == 2" id="tmPassingDate" [(ngModel)]="confirmShipPassingRequest.PassingDate" name="PassingDate" [hourStep]="1" [minuteStep]="1"></timepicker>
                            <div *ngIf="isPassingDateNotValid" class="red">
                                <span>This Field is Required</span>
                            </div>
                            <div *ngIf="isPassingdateSeventy" class="red">
                                <span>70 days rule violation</span>
                            </div>
                        </div>
                        <!-- Granted Rebate Percentage -->
                        <div *ngIf="isOptionDetailsEnabled" class="form-group">
                            <label for="txtGrantedRebatePercentage">Granted Rebate Percentage</label>
                            <span *ngIf="formMode == 1" class="red"> *</span>
                            <div class="input-group">
                                <input [disabled]="formMode == 2" type="text"  minlength="1" min="0" max="100" maxlength="4" [(ngModel)]="confirmShipPassingRequest.GrantedRebatePercentage" name="grantedRebatePercentage" id="txtGrantedRebatePercentage" class="form-control" required #txtGrantedRebatePercentage="ngModel" />
                                <span class="input-group-addon">%</span>
                            </div>
                            <div *ngIf="txtGrantedRebatePercentage?.invalid" class="red">
                                <span *ngIf="txtGrantedRebatePercentage?.errors?.required">This Field is Required</span>
                            </div>
                            <div *ngIf="txtGrantedRebatePercentage?.invalid" class="red">
                                <span *ngIf="txtGrantedRebatePercentage?.errors?.pattern">Please enter a Valid Rebate Percentage Number</span>
                            </div> 
                        </div>
                    </div>
                    <div class="form-section">
                        <!-- Mark Closed -->
                        <div class="form-group">
                            <label for="chkMarkClosed">Close Request</label>
                            <div class="custom-checkbox">
                                <input [disabled]="formMode == 2" type="checkbox" [(ngModel)]="confirmShipPassingRequest.IsRequestClosed" name="MarkClosed" id="chkMarkClosed">
                                <label for="chkMarkClosed">Mark Request as Closed</label>                                                
                            </div>
                        </div>
                    </div>    
                </div>
                <div *ngIf="formMode == 1" class="form-group">
                    <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="isFormSubmitted = true; f.form.valid && submit()">Submit</button>
                    <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
                </div>
            </form>
        </div>
    </div>
    <!-- Confirmation -->
    <div *ngIf="isRequestSucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
        <div class="alignC">
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g>
                    <g>
                        <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                    </g>
                </g>
            </svg>
            <p>You have confirmed Ship passing for this Rebate Request</p>
            <p>Go Back to <a routerLink="/RebateRequest/RequestsManagement">Requests Management</a></p>
        </div>
    </div>
    <!-- Warning -->
    <div *ngIf="isRequestSucceeded && submitConfirmationMode == 2" class="alert alert-warning" role="alert">
        <div class="alignC">
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g>
                    <g>
                        <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                    </g>
                </g>
            </svg>
            <p>This task was submitted before</p>
            <p>Go Back to <a routerLink="/RebateRequest/RequestsManagement">Requests Management</a></p>
        </div>
    </div>
    <!-- Error -->
    <div *ngIf="isRequestSucceeded && submitConfirmationMode == 3" class="alert alert-danger" role="alert">
        <div class="alignC">
            <i class="icon-error"></i>
            <p>Something went wrong, Please contact System Administrator</p>
            <hr>
            <p>Go Back to <a routerLink="/workspace">Workspace</a></p>
        </div>
    </div>
<!-- </div> -->